import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as userActions from '../../actions/userActions';
import * as layoutActions from '../../actions/layoutActions';
import BasicGrid, {
    ACTION_OPEN_AUDIT,
    ACTION_REINSTATE,
    ACTION_VOYAGE_ACTIVITY,
    ACTION_COPY_FIXTURE_WITH_POS_INFO,
    ACTION_COPY_FIXTURE_WITH_CARGO_INFO,
} from '../grid/BasicGrid';
import { bindActionCreators } from 'redux';
import createGridCellValueSetter from '../grid/setters/createGridCellValueSetter';
import { currentGridCreationIndex } from '../../reducers/userSelectors';
import {
    REINSTATE_FIXTURE_MUTATION,
    DELETE_FIXTURE_MUTATION,
    MAKE_FIXTURE_PUBLIC_MUTATION,
    MAKE_FIXTURE_PRIVATE_MUTATION,
    UPDATE_FIXTURE_PRIVATE_FIELDS_MUTATION,
    SHARE_FIXTURE_MUTATION,
    SHARE_FIXTURE_TO_GROUP_MUTATION,
    CLONE_FIXTURE_WITH_POS_INFO_MUTATION,
    CLONE_FIXTURE_WITH_CARGO_INFO_MUTATION,
    createFixtureFieldMutation,
} from '../../api/queries/fixtures/FixtureQueries';
import FixtureHeadings from './FixtureHeadings';
import StripedLoader from '../common/StripedLoader';
import AddFixture from './AddFixture';
import graphQlClient from '../../api/graphQlClient';
import {
    FIXTURE_ADDED_SUBSCRIPTION,
    FIXTURE_UPDATED_SUBSCRIPTION,
    FIXTURE_SHARED_SUBSCRIPTION,
    FIXTURE_VISIBILITY_UPDATED_SUBSCRIPTION,
} from '../../api/subscriptions/fixtureSubscriptions';
import { FIXTURE_GRID_TYPE } from '../../constants/gridTypes';
import { commonRowAndCellClassRules } from '../grid/classRules/classRules';
import logger from '../../diagnostics/logging/logger';
import Axios from 'axios';
import { FixtureApi } from '../../api/fixtureApi';
import layoutsApi from '../../api/layoutsApi';
import moment from 'moment';
import Activity, { ActivityTabs } from '../ui/Activity';
import { CSSTransition } from 'react-transition-group';
import Toolbar from '../toolbar/Toolbar';
import MoreButton from '../toolbar/MoreButton';
import ReportsButton from '../toolbar/ReportsButton';
import DataButton from '../toolbar/DataButton';
import ExportButton from '../toolbar/ExportButton';
import SyncButton from '../toolbar/SyncButton';
import SwitchGroup from '../group/SwitchGroup';
import { KEY_CODES } from 'constant';
import { encodeDataSetId } from '../analytics/AdvancedAnalyticsPage';
import {
    getDataset,
    tankersUnstructuredDatasetIds,
} from '../../models/Datasets';
import MixpanelLogger from '../../diagnostics/logging/mixpanelLogger';
import { withApollo } from '@apollo/client/react/hoc';
import Filters from '../toolbar/filters/Filters';
import {
    getCreatedLayoutPropertiesForMixpanel,
    sendSaveLayoutMixpanelEvent,
} from '../../tools/LayoutTools';
import defaultGroupSortComparator from '../grid/comparators/DefaultGroupSortComparator';
import GroupingFixturesToolPanel from '../toolPanels/grouping/GroupingFixturesToolPanel';
import { ChipOutlined } from '../ui/ChipOutlined';
import { compareColumnPropertyState } from '../common/gridColumnsUtils';
import LayoutsDropdownMenu from 'components/toolbar/LayoutsDropdownMenu';
import {
    changeCollapsedRowGroups,
    changeGridSettings,
    ensureDefaultColumns,
    ensureInitialLayout,
} from 'store/feature/layoutsSlice';
import { isReportedDateValid } from '_legacy/modules/columns/reportedDate/ReportedDateHeading';
import { GridContextProvider } from 'hooks/grid/useGridContext';
import { GridUtils } from 'hooks/grid/useGridContext/utils';
import { isVisible } from '../common/VisibilityUtils';
import {
    customFixtureGroupHeaders,
    getGroupingText,
} from '../common/GroupHeader';
import OpenFullscreenTabButton from '../toolbar/OpenFullscreenTabButton';
import { isGroupOnly } from '_legacy/utils/Visibility';
import dataSizeOptions from '../../data/dataSizeOptions';

const CancelToken = Axios.CancelToken;

const { CTRL, KEY_1, KEY_2, KEY_R, KEY_D, ALT } = KEY_CODES;

export class FixturesPage extends Component {
    getFixtureId = (fixture) => fixture.id || fixture.shadowId;

    constructor(props) {
        super(props);
        this.basicGridRef = React.createRef();
        this.showCondensedToggleRef = React.createRef();
        this.handleSidebarClickOutside =
            this.handleSidebarClickOutside.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.setFilters = this.setFilters.bind(this);
        this.handleNewFixture = this.handleNewFixture.bind(this);

        this.onLayoutAdded = this.onLayoutAdded.bind(this);
        this.handleNewFixtureAdded = this.handleNewFixtureAdded.bind(this);
        this.handleFixtureUpdated = this.handleFixtureUpdated.bind(this);

        this.removeSubscriptions = this.removeSubscriptions.bind(this);
        this.setupSubscriptions = this.setupSubscriptions.bind(this);
        this.handleGridReady = this.handleGridReady.bind(this);

        this.handleGridOptionsChanged =
            this.handleGridOptionsChanged.bind(this);
        this.refreshLayout = this.refreshLayout.bind(this);
        this.resetAddedSessionIndex = this.resetAddedSessionIndex.bind(this);
        this.loadFixtures = this.loadFixtures.bind(this);

        this.makePublic = this.makePublic.bind(this);
        this.makePrivate = this.makePrivate.bind(this);
        this.makeUnRumoured = this.makeUnRumoured.bind(this);
        this.makeRumoured = this.makeRumoured.bind(this);
        this.delete = this.delete.bind(this);
        this.share = this.share.bind(this);
        this.shareToGroup = this.shareToGroup.bind(this);

        this.handleFixtureShared = this.handleFixtureShared.bind(this);
        this.handleFixtureVisibilityUpdated =
            this.handleFixtureVisibilityUpdated.bind(this);
        this.updatePrivateFields = this.updatePrivateFields.bind(this);
        this.updateRumouredFields = this.updateRumouredFields.bind(this);

        this.handleSelectionChanged = this.handleSelectionChanged.bind(this);
        this.exportSelectedChanged = this.exportSelectedChanged.bind(this);
        this.exportToExcel = this.exportToExcel.bind(this);
        this.exportToEmail = this.getEmailReportData.bind(this);
        this.getExportColumnsNumber = this.getExportColumnsNumber.bind(this);
        this.toggleShowCondensed = this.toggleShowCondensed.bind(this);
        this.toggleShowDeleted = this.toggleShowDeleted.bind(this);
        this.toggleOnlyDisplayRumouredFixtures =
            this.toggleOnlyDisplayRumouredFixtures.bind(this);

        this.reinstate = this.reinstate.bind(this);
        this.handleOpenVoyageActivity =
            this.handleOpenVoyageActivity.bind(this);
        this.copyFixture = this.copyFixture.bind(this);
        this.copyFixtureWithCargoInfo =
            this.copyFixtureWithCargoInfo.bind(this);
        this.handleCanPerformAction = this.handleCanPerformAction.bind(this);

        this.toggleAddLayoutDialog = this.toggleAddLayoutDialog.bind(this);
        this.onResetLayout = this.onResetLayout.bind(this);

        this.trackAuditHistoryEvent = this.trackAuditHistoryEvent.bind(this);
        this.trackAnalyticEvent = this.trackAnalyticEvent.bind(this);
        this.handleOnCellEditingStopped =
            this.handleOnCellEditingStopped.bind(this);

        //hold initial grid info in state so we don't keep re-rendering
        //the grid everytime they change a column/filter/sort/group
        const { creationIndex: createdIndex, exportParams } = this.props;
        this.vesselView = !!this.props.vesselImo;

        this.state = {
            canRestoreFilters: false,
            filters: {},
            collapseSidebar: true,
            queuedUpdates: [],
            queuedAdds: [],
            gridReady: false,
            itemAddedSessionIndex: null,
            createdIndex,
            fixturesLoaded: false,
            export: exportParams,
            exportColIdsToSkip: ['privacyWarning', 'isSelected', 'privacy'],
            activeSlide: null,
            showCondensed: false,
            selectedFixtures: [],
            numberOfYears: this.vesselView ? 0 : this.props.numberOfYears,
            vesselImo:
                this.props.vesselImo !== undefined
                    ? +this.props.vesselImo
                    : undefined,
            showAddLayout: false,
            layoutWasReset: false,
            activity: {},
            itemsToAddOnEditStopped: [],
        };

        this.setValueSetter();

        this.cancelSource = null;
    }

    handleGridReady() {
        this.setState({
            gridReady: true,
        });

        this.setState((state) => {
            for (let index = 0; index < state.queuedAdds.length; index++) {
                const fixture = state.queuedAdds[index];
                this.handleNewFixtureAdded(fixture);
            }

            for (let index = 0; index < state.queuedUpdates.length; index++) {
                const fixture = state.queuedUpdates[index];
                this.handleFixtureUpdated(fixture);
            }

            return {
                queuedUpdates: [],
                queuedAdds: [],
            };
        });
    }

    removeSubscriptions() {
        if (this.fixtureAddedSubscription) {
            this.fixtureAddedSubscription.unsubscribe();
        }
        if (this.fixtureUpdatedSubscription) {
            this.fixtureUpdatedSubscription.unsubscribe();
        }
        if (this.fixtureSharedSubscription) {
            this.fixtureSharedSubscription.unsubscribe();
        }
        if (this.fixtureVisibilitySubscription) {
            this.fixtureVisibilitySubscription.unsubscribe();
        }
    }

    setupSubscriptions() {
        this.removeSubscriptions();
        if (this.props.groupId) {
            this.fixtureAddedSubscription = graphQlClient()
                .subscribe({
                    query: FIXTURE_ADDED_SUBSCRIPTION,
                    variables: {
                        groupId: this.props.groupId,
                        vesselImo: this.state.vesselImo,
                    },
                    fetchPolicy: 'no-cache',
                })
                .subscribe({
                    next: this.handleNewFixtureAdded,
                    error(err) {
                        logger.warn(
                            'SUBSCRIPTION FIXTURE ERROR ADDED' + err.message
                        );
                    },
                });

            this.fixtureUpdatedSubscription = graphQlClient()
                .subscribe({
                    query: FIXTURE_UPDATED_SUBSCRIPTION,
                    variables: {
                        groupId: this.props.groupId,
                    },
                    fetchPolicy: 'no-cache',
                })
                .subscribe({
                    next: this.handleFixtureUpdated,
                    error(err) {
                        logger.warn(
                            'SUBSCRIPTION FIXTURE ERROR UPDATED' + err.message
                        );
                    },
                });

            this.fixtureSharedSubscription = graphQlClient()
                .subscribe({
                    query: FIXTURE_SHARED_SUBSCRIPTION,
                    variables: {
                        groupId: this.props.groupId,
                        vesselImo: this.state.vesselImo,
                    },
                    fetchPolicy: 'no-cache',
                })
                .subscribe({
                    next: this.handleFixtureShared,
                    error(err) {
                        logger.warn(
                            'SUBSCRIPTION FIXTURE ERROR SHARED' + err.message
                        );
                    },
                });

            this.fixtureVisibilitySubscription = graphQlClient()
                .subscribe({
                    query: FIXTURE_VISIBILITY_UPDATED_SUBSCRIPTION,
                    variables: {
                        groupId: this.props.groupId,
                        vesselImo: this.state.vesselImo,
                    },
                    fetchPolicy: 'no-cache',
                })
                .subscribe({
                    next: this.handleFixtureVisibilityUpdated,
                    error(err) {
                        logger.warn(
                            'SUBSCRIPTION FIXTURE ERROR VISIBILITY' +
                                err.message
                        );
                    },
                });
        }
    }

    componentDidMount() {
        logger.trackPageView('Fixtures');

        if (this.props.groupId) {
            this.loadFixtures();
        }

        this.setupSubscriptions();
    }

    createDataResetState() {
        return {
            loadingFixtures: false,
            fixturesLoaded: false,
            fixturesLoadedDatasetId: null,
            fixtureLoadingError: null,
            fixtures: null,
        };
    }

    get reportedDateCutOff() {
        if (this.state.numberOfYears === 0) {
            return moment().subtract(100, 'years').startOf('day').toDate();
        } else if (this.state.numberOfYears === 0.5) {
            return moment().subtract(6, 'months').startOf('day').toDate();
        } else {
            return moment()
                .subtract(this.state.numberOfYears, 'years')
                .startOf('day')
                .toDate();
        }
    }

    // Returns the number of years to pass to the API. The backend uses 105 as
    // the identifier for the half-year (6 months) time period.
    get apiNumberOfYears() {
        return this.state.numberOfYears === 0.5
            ? 105
            : this.state.numberOfYears;
    }

    isFixtureOutsideDisplayedDataRange(fixture) {
        return moment(fixture.reportedDate).isBefore(this.reportedDateCutOff);
    }

    loadFixtures() {
        if (this.cancelSource) {
            this.cancelSource.cancel();
        }

        if (this.props.gridData) {
            this.setState(this.createDataResetState());
            return;
        }

        this.cancelSource = CancelToken.source();

        this.setState((state, props) => {
            if (this.vesselView) {
                FixtureApi.fetchVesselFixtures(
                    this.props.groupId,
                    this.apiNumberOfYears,
                    this.cancelSource.token,
                    this.props.selectedLayout.fixtures.currentOptions
                        .shouldShowDeletedFixtures,
                    this.state.vesselImo
                ).then(
                    (results) => {
                        const lastVesselName = results
                            .filter((fixture) => fixture.vessel?.imo != null)
                            .sort(
                                (a, b) =>
                                    new Date(b.lastUpdated).getTime() -
                                    new Date(a.lastUpdated).getTime()
                            )[0]?.vessel?.name;

                        this.setState({
                            loadingFixtures: false,
                            fixturesLoaded: true,
                            fixturesLoadedDatasetId: props.datasetId,
                            fixtureLoadingError: null,
                            fixtures: results,
                            vesselName: lastVesselName,
                        });
                    },
                    (error) => {
                        this.setState({
                            loadingFixtures: false,
                            fixturesLoaded: false,
                            fixturesLoadedDatasetId: null,
                            fixtureLoadingError: error,
                            fixtures: null,
                        });
                    }
                );
            } else {
                FixtureApi.fetchFixtures(
                    this.props.groupId,
                    this.props.datasetId,
                    this.apiNumberOfYears,
                    this.cancelSource.token,
                    this.props.selectedLayout.fixtures.currentOptions
                        .shouldShowDeletedFixtures,
                    this.props.selectedLayout.fixtures.currentOptions
                        .shouldOnlyDisplayRumouredFixtures
                ).then(
                    (results) => {
                        this.setState({
                            loadingFixtures: false,
                            fixturesLoaded: true,
                            fixturesLoadedDatasetId: props.datasetId,
                            fixtureLoadingError: null,
                            fixtures: results,
                        });
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        this.setState({
                            loadingFixtures: false,
                            fixturesLoaded: false,
                            fixturesLoadedDatasetId: null,
                            fixtureLoadingError: error,
                            fixtures: null,
                        });
                    }
                );
            }
            return {
                loadingFixtures: true,
                fixturesLoaded: false,
                fixturesLoadedDatasetId: null,
                fixtureLoadingError: null,
                fixtures: null,
            };
        });
    }

    componentWillUnmount() {
        this.removeSubscriptions();
        if (this.cancelSource) {
            this.cancelSource.cancel();
        }
    }

    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) return false;
        }
        return true;
    }

    handleOnCellEditingStopped(params) {
        this.setState((prev) => {
            if (prev.itemsToAddOnEditStopped?.length) {
                prev.itemsToAddOnEditStopped.forEach((item) => {
                    this.handleNewFixture(item, false);
                });
                return {
                    itemsToAddOnEditStopped: [],
                };
            }
        });
    }

    handleNewFixture(data, startEditing = true) {
        const cellsInEdit =
            this.basicGridRef.current._gridApi.getEditingCells();
        if (!!cellsInEdit?.length) {
            this.setState((prev) => {
                return {
                    itemsToAddOnEditStopped: [
                        data,
                        ...prev.itemsToAddOnEditStopped,
                    ],
                };
            });
            return;
        }

        const addRowFunction = () => {
            if (this.basicGridRef.current) {
                this.basicGridRef.current.addRow(data, startEditing);
                GridUtils.wrapFilterInstances(
                    this.basicGridRef.current._gridApi
                );
            }
        };

        if (this.props.userId === data.createdBy.userId) {
            // Only apply sorting indexes if the fixture was created by the user
            data.createdIndex = this.state.createdIndex;
            const newCreatedIndex = this.state.createdIndex + 1;

            const newSessionIndex =
                this.state.itemAddedSessionIndex !== null
                    ? this.state.itemAddedSessionIndex
                    : data.createdIndex;

            this.setState(
                {
                    createdIndex: newCreatedIndex,
                    itemAddedSessionIndex: newSessionIndex,
                },
                () => {
                    addRowFunction();
                    this.props.actions.userCreationIndexSet(newCreatedIndex);
                }
            );
        } else {
            addRowFunction();
        }
    }

    handleNewFixtureAdded(data) {
        const {
            data: { fixtureAdded: fixture },
        } = data;

        if (fixture.datasetId !== this.props.datasetId) {
            //do nothing
            return;
        }

        //let the basic grid work out what to do with it
        if (this.state.gridReady) {
            this.handleNewFixture(fixture, false);
        } else {
            this.setState((state) => {
                return {
                    queuedAdds: [...state.queuedAdds, data],
                };
            });
        }
    }

    handleFixtureVisibilityUpdated(data) {
        if (!data?.data?.fixtureVisibilityUpdated) {
            return;
        }

        const updatedFixture = data.data.fixtureVisibilityUpdated;
        try {
            if (
                !isVisible(
                    updatedFixture.visibility,
                    this.props.groupId,
                    this.props.userId
                )
            ) {
                this.basicGridRef.current?.rowDeleted(updatedFixture);
            } else {
                this.basicGridRef.current?.rowUpdated(updatedFixture);
            }
        } catch (error) {
            logger.warn(`Error updating cache for fixture visibility`);
        }
    }

    handleFixtureUpdated(data) {
        const {
            data: { fixtureUpdated: fixture },
        } = data;
        if (fixture.datasetId !== this.props.datasetId) {
            //do nothing
            return;
        }

        if (this.isFixtureOutsideDisplayedDataRange(fixture)) {
            this.basicGridRef.current.rowDeleted(fixture);
            return;
        }

        //let the basic grid work out what to do with it
        if (this.state.gridReady) {
            if (
                fixture.state === 'deleted' &&
                !this.props.selectedLayout.fixtures.currentOptions
                    .shouldShowDeletedFixtures
            ) {
                this.basicGridRef.current.rowDeleted(fixture);
            } else if (
                this.vesselView &&
                (!fixture.vessel || fixture.vessel.imo !== this.state.vesselImo)
            ) {
                this.basicGridRef.current.rowDeleted(fixture);
            } else {
                const cellsInEdit =
                    this.basicGridRef.current._gridApi.getEditingCells();
                const addedFixture = this.state.itemsToAddOnEditStopped?.find(
                    (x) => fixture.id == x.id
                );
                if (!!cellsInEdit?.length && !!addedFixture) {
                    this.setState((prev) => {
                        const updatedItems = [...prev.itemsToAddOnEditStopped];
                        const updatedItemIndex =
                            updatedItems.indexOf(addedFixture);
                        updatedItems[updatedItemIndex] = fixture;
                        return {
                            itemsToAddOnEditStopped: updatedItems,
                        };
                    });
                } else {
                    this.basicGridRef.current.rowUpdated(fixture);
                }
            }
        } else {
            this.setState((state) => {
                return {
                    queuedUpdates: [...state.queuedUpdates, data],
                };
            });
        }
    }

    handleFixtureShared(data) {
        const {
            data: { fixtureShared: fixture },
        } = data;

        this.basicGridRef.current.rowUpdated(fixture);
    }

    handleOpenAuditActivity = () => {
        this.toggleActivity({ selectedTab: ActivityTabs.AUDIT });
    };

    handleOpenVoyageActivity() {
        this.toggleActivity({ selectedTab: ActivityTabs.VOYAGE_ACTIVITY });
    }

    setFilters(filters) {
        this.basicGridRef.current.setFilterOptions(filters);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.groupId !== prevProps.groupId ||
            this.props.numberOfYears !== prevProps.numberOfYears ||
            this.state.numberOfYears !== prevState.numberOfYears ||
            this.props.datasetId !== prevProps.datasetId ||
            this.state.layoutWasReset ||
            this.props.selectedLayout.fixtures.currentOptions
                .shouldOnlyDisplayRumouredFixtures !==
                prevProps.selectedLayout.fixtures.currentOptions
                    .shouldOnlyDisplayRumouredFixtures ||
            this.props.selectedLayout.fixtures.currentOptions
                .shouldShowDeletedFixtures !==
                prevProps.selectedLayout.fixtures.currentOptions
                    .shouldShowDeletedFixtures
        ) {
            const newState = {
                layoutWasReset: false,
                queuedAdds: [],
                queuedUpdates: [],
                ...this.createDataResetState(),
            };

            this.setState(newState);

            this.setupSubscriptions();

            this.setValueSetter();
            this.loadFixtures();
        } else if (this.exportSelectedChanged()) {
            this.setState({ export: this.props.exportParams });
        }
    }

    exportSelectedChanged = () =>
        this.props.exportParams.fixtures.length !==
            this.state.export.fixtures.length ||
        this.props.exportParams?.orders?.length !==
            this.state.export?.orders?.length;

    setValueSetter() {
        const { userId, username, groupId } = this.props;
        this.fixtureValueSetter = createGridCellValueSetter({
            username,
            userId,
            groupId,
            createMutation: createFixtureFieldMutation,
        });
    }

    clearFilters() {
        if (this.basicGridRef.current) {
            this.basicGridRef.current.clearFilters();
        }
    }

    refreshLayout() {
        this.resetAddedSessionIndex(true);
        if (this.basicGridRef.current) {
            this.basicGridRef.current.rowData.forEach((x) => {
                delete x.__createdInCurrentSession;
            });
        }
    }

    onLayoutAdded(newLayout) {
        const orderGridOptions = this.getMixpanelOrdersGridOptions();
        this.sendCreateLayoutMixpanelEvent(
            newLayout.name,
            'Order',
            newLayout.orders,
            newLayout.commonSettings.directionLogic,
            newLayout.commonSettings.quantityFormat,
            orderGridOptions
        );

        const localGridOptions = this.getMixpanelGridOptions();
        this.sendCreateLayoutMixpanelEvent(
            newLayout.name,
            'Fixture',
            newLayout.fixtures,
            newLayout.commonSettings.directionLogic,
            newLayout.commonSettings.quantityFormat,
            localGridOptions
        );
    }

    getCurrentLayout = () => {
        return this.props.allLayouts.find(
            (l) => l.id === this.props.selectedLayout.selectedLayoutId
        );
    };

    toggleAddLayoutDialog() {
        this.setState((prevState) => ({
            showAddLayout: !prevState.showAddLayout,
        }));
    }

    resetAddedSessionIndex(forceRefreshGrid = false) {
        if (this.state.itemAddedSessionIndex !== null) {
            this.setState(
                {
                    itemAddedSessionIndex: null,
                },
                () => {
                    if (this.basicGridRef.current) {
                        this.basicGridRef.current.refreshRowModel();
                    }
                }
            );
        } else if (forceRefreshGrid && this.basicGridRef.current) {
            this.basicGridRef.current.refreshRowModel();
        }
    }

    handleSidebarClickOutside() {
        this.setState({
            collapseSidebar: !this.state.collapseSidebar,
        });
    }

    makePublic(fixture) {
        this.props.client
            .mutate({
                mutation: MAKE_FIXTURE_PUBLIC_MUTATION,
                variables: {
                    groupId: this.props.groupId,
                    id: fixture.id,
                },
                context: {
                    errorHandling: {
                        unknownResult: {
                            resolution: {
                                isSafeToRetry: true,
                            },
                        },
                    },
                },
                fetchPolicy: 'no-cache',
            })
            .then((result) => {
                const updatedFixture = result.data.makeFixturePublic;
                fixture.privacy = updatedFixture.privacy;
                fixture.privateFields = updatedFixture.privateFields;
                fixture.lastUpdatedDateTimeByUser =
                    updatedFixture.lastUpdatedDateTimeByUser;
                fixture.lastUpdatedByUser = updatedFixture.lastUpdatedByUser;
                this.basicGridRef.current.rowUpdated(fixture);
            });
    }

    makePrivate(fixture) {
        this.props.client
            .mutate({
                mutation: MAKE_FIXTURE_PRIVATE_MUTATION,
                variables: {
                    groupId: this.props.groupId,
                    id: fixture.id,
                },
                context: {
                    errorHandling: {
                        unknownResult: {
                            resolution: {
                                isSafeToRetry: true,
                            },
                        },
                    },
                },
                fetchPolicy: 'no-cache',
            })
            .then((result) => {
                const updatedFixture = result.data.makeFixturePrivate;
                fixture.privacy = updatedFixture.privacy;
                fixture.privateFields = updatedFixture.privateFields;
                fixture.lastUpdatedDateTimeByUser =
                    updatedFixture.lastUpdatedDateTimeByUser;
                fixture.lastUpdatedByUser = updatedFixture.lastUpdatedByUser;
                this.basicGridRef.current.rowUpdated(fixture);
            });
    }

    makeUnRumoured(fixture) {
        const variables = {
            groupId: this.props.groupId,
            id: fixture.id,
        };

        FixtureApi.makeUnRumoured(this.props.client, variables).then(
            (updatedFixture) => {
                fixture.rumoured = updatedFixture.rumoured;
                fixture.rumouredFields = updatedFixture.rumouredFields;
                fixture.lastUpdatedDateTimeByUser =
                    updatedFixture.lastUpdatedDateTimeByUser;
                fixture.lastUpdatedByUser = updatedFixture.lastUpdatedByUser;

                if (
                    !this.props.selectedLayout.fixtures.currentOptions
                        .shouldOnlyDisplayRumouredFixtures
                ) {
                    this.basicGridRef.current.rowUpdated(fixture);
                } else {
                    this.basicGridRef.current.rowDeleted(fixture);
                }
            }
        );
    }

    makeRumoured(fixture) {
        const variables = {
            groupId: this.props.groupId,
            id: fixture.id,
        };

        FixtureApi.makeRumoured(this.props.client, variables).then(
            (updatedFixture) => {
                fixture.rumoured = updatedFixture.rumoured;
                fixture.rumouredFields = updatedFixture.rumouredFields;
                fixture.lastUpdatedDateTimeByUser =
                    updatedFixture.lastUpdatedDateTimeByUser;
                fixture.lastUpdatedByUser = updatedFixture.lastUpdatedByUser;
                this.basicGridRef.current.rowUpdated(fixture);
            }
        );
    }

    reinstate(fixture) {
        this.props.client
            .mutate({
                mutation: REINSTATE_FIXTURE_MUTATION,
                variables: {
                    groupId: this.props.groupId,
                    id: fixture.id,
                },
                context: {
                    errorHandling: {
                        unknownResult: {
                            resolution: {
                                isSafeToRetry: true,
                            },
                        },
                    },
                },
                fetchPolicy: 'no-cache',
            })
            .then((result) => {
                const updatedFixture = result.data.reinstateFixture;
                fixture.state = updatedFixture.state;
                fixture.lastUpdatedDateTimeByUser =
                    updatedFixture.lastUpdatedDateTimeByUser;
                fixture.lastUpdatedByUser = updatedFixture.lastUpdatedByUser;
                this.basicGridRef.current.rowUpdated(fixture);
            });
    }

    copyFixture(fixture) {
        this.props.client
            .mutate({
                mutation: CLONE_FIXTURE_WITH_POS_INFO_MUTATION,
                variables: {
                    id: fixture.id,
                    groupId: this.props.groupId,
                },
                context: {
                    errorHandling: {
                        unknownResult: {
                            resolution: {
                                isSafeToRetry: true,
                            },
                        },
                    },
                },
                fetchPolicy: 'no-cache',
            })
            .then((result) => {
                const newFixture = result.data.cloneFixtureWithPosInfo;

                this.logCopyFixture(newFixture, 'Copied with position info');
                this.basicGridRef.current.addRow(newFixture);
            });
    }

    copyFixtureWithCargoInfo(fixture) {
        this.props.client
            .mutate({
                mutation: CLONE_FIXTURE_WITH_CARGO_INFO_MUTATION,
                variables: {
                    id: fixture.id,
                    groupId: this.props.groupId,
                },
                context: {
                    errorHandling: {
                        unknownResult: {
                            resolution: {
                                isSafeToRetry: true,
                            },
                        },
                    },
                },
                fetchPolicy: 'no-cache',
            })
            .then((result) => {
                const newFixture = result.data.cloneFixtureWithCargoInfo;

                this.logCopyFixture(newFixture, 'Copied with Cargo info');
                this.basicGridRef.current.addRow(newFixture);
            });
    }

    logCopyFixture(newFixture, actionName) {
        const { id, privacy, groupName, visibility } = newFixture;

        MixpanelLogger.trackNewFixtureEvent(
            id,
            isGroupOnly(visibility),
            privacy,
            groupName,
            actionName
        );
    }

    delete(fixture) {
        this.props.client
            .mutate({
                mutation: DELETE_FIXTURE_MUTATION,
                variables: {
                    groupId: this.props.groupId,
                    id: fixture.id,
                },
                context: {
                    errorHandling: {
                        unknownResult: {
                            resolution: {
                                isSafeToRetry: true,
                            },
                        },
                    },
                },
                fetchPolicy: 'no-cache',
            })
            .then((result) => {
                if (this.state.showDeleted) {
                    this.basicGridRef.current.rowUpdated(
                        result.data.deleteFixture
                    );
                } else {
                    this.basicGridRef.current.rowDeleted(
                        result.data.deleteFixture
                    );
                }
            });
    }

    share(fixture) {
        this.props.client
            .mutate({
                mutation: SHARE_FIXTURE_MUTATION,
                variables: {
                    id: fixture.id,
                },
                context: {
                    errorHandling: {
                        unknownResult: {
                            resolution: {
                                isSafeToRetry: true,
                            },
                        },
                    },
                },
                fetchPolicy: 'no-cache',
            })
            .then((result) => {
                this.basicGridRef.current.rowUpdated(result.data.shareFixture);
            });
    }

    shareToGroup(fixture) {
        this.props.client
            .mutate({
                mutation: SHARE_FIXTURE_TO_GROUP_MUTATION,
                variables: {
                    id: fixture.id,
                },
                context: {
                    errorHandling: {
                        unknownResult: {
                            resolution: {
                                isSafeToRetry: true,
                            },
                        },
                    },
                },
                fetchPolicy: 'no-cache',
            })
            .then((result) => {
                if (this.props.groupId !== fixture.groupId) {
                    this.basicGridRef.current.rowDeleted(
                        result.data.shareFixtureToGroup
                    );
                } else {
                    this.basicGridRef.current.rowUpdated(
                        result.data.shareFixtureToGroup
                    );
                }
            });
    }

    updatePrivateFields(fixture, fields) {
        this.props.client
            .mutate({
                mutation: UPDATE_FIXTURE_PRIVATE_FIELDS_MUTATION,
                variables: {
                    groupId: this.props.groupId,
                    id: fixture.id,
                    fields: fields,
                },
                context: {
                    errorHandling: {
                        unknownResult: {
                            resolution: {
                                isSafeToRetry: true,
                            },
                        },
                    },
                },
                fetchPolicy: 'no-cache',
            })
            .then((result) => {
                const updatedFixture = result.data.updateFixturePrivateFields;
                fixture.privateFields = updatedFixture.privateFields;
                fixture.privacy = updatedFixture.privacy;
                fixture.lastUpdatedDateTimeByUser =
                    updatedFixture.lastUpdatedDateTimeByUser;
                fixture.lastUpdatedByUser = updatedFixture.lastUpdatedByUser;
                this.basicGridRef.current.rowUpdated(fixture);
            });
    }

    updateRumouredFields(fixture, fields) {
        const variables = {
            groupId: this.props.groupId,
            id: fixture.id,
            fields: fields,
        };

        FixtureApi.updateRumouredFields(this.props.client, variables).then(
            (updatedFixture) => {
                fixture.rumoured = updatedFixture.ruomured;
                fixture.rumouredFields = updatedFixture.rumouredFields;
                fixture.lastUpdatedDateTimeByUser =
                    updatedFixture.lastUpdatedDateTimeByUser;
                fixture.lastUpdatedByUser = updatedFixture.lastUpdatedByUser;

                if (
                    !this.props.selectedLayout.fixtures.currentOptions
                        .shouldOnlyDisplayRumouredFixtures
                ) {
                    this.basicGridRef.current.rowUpdated(fixture);
                } else {
                    this.basicGridRef.current.rowDeleted(fixture);
                }
            }
        );
    }

    handleSelectionChanged() {
        setTimeout(() => {
            if (this.basicGridRef.current) {
                const selected = this.basicGridRef.current.getSelectedNodes();

                // WARNING: react-grid exports only visible nodes, and the only indication I found that a node is not rendered is rowTop === null, this is not documented behaviour
                const visibleSelected = selected.filter(
                    ({ rowTop }) => rowTop !== null
                );

                const containsPrivate = visibleSelected.some(
                    (node) => node.data.privacy
                );

                const containsPublic = visibleSelected.some(
                    (node) => !node.data.privacy
                );

                this.setState({
                    selectedFixtures: visibleSelected,
                });

                if (this.props.onSelectionChanged) {
                    this.props.onSelectionChanged({
                        ...this.state.export,
                        includesNonConfidentialFixtures: containsPublic,
                        includesConfidentialFixtures: containsPrivate,
                        fixtures: visibleSelected,
                    });
                }
            }
        });
    }

    exportToExcel(shouldIncludeRow, shouldExportGroupHeadings) {
        if (this.basicGridRef.current) {
            this.basicGridRef.current.export(
                shouldIncludeRow,
                shouldExportGroupHeadings
            );
        }
    }

    getEmailReportData(shouldIncludeRow) {
        if (this.basicGridRef.current) {
            const reportData =
                this.basicGridRef.current.getEmailReportData(shouldIncludeRow);
            return { fixturesReportData: reportData };
        }
    }

    getExportColumnsNumber() {
        if (this.basicGridRef.current) {
            return this.basicGridRef.current.getExportColumnsNumber();
        }
    }

    getAuditParams() {
        let displayedColumns = [];
        const { filterOptions } =
            this.props.selectedLayout.fixtures.currentOptions;
        const { groupId } = this.props;

        if (this.basicGridRef.current) {
            displayedColumns = this.basicGridRef.current.getDisplayedColumns();
        }

        return {
            groupId,
            filterOptions,
            displayedColumns,
        };
    }

    handleCanPerformAction(action) {
        switch (action) {
            case ACTION_OPEN_AUDIT:
            case ACTION_REINSTATE:
            case ACTION_VOYAGE_ACTIVITY:
                return true;
            case ACTION_COPY_FIXTURE_WITH_POS_INFO:
                return this.props.canEdit;
            case ACTION_COPY_FIXTURE_WITH_CARGO_INFO:
                return this.props.canEdit;
            default:
                return false;
        }
    }

    toggleSlide = (name) => {
        const isOpen = this.state.activeSlide === name;
        const { selectedTab } = this.state.activity;

        if (!isOpen && selectedTab === ActivityTabs.ANALYTICS) {
            this.trackAnalyticEvent();
        }

        this.setState({ activeSlide: isOpen ? null : name });
    };

    toggleActivity = ({ selectedTab = ActivityTabs.ANALYTICS } = {}) => {
        this.setState(
            {
                activity: {
                    selectedTab,
                },
            },
            () => this.toggleSlide('activity')
        );
    };

    onResetLayout() {
        this.setState({ layoutWasReset: true });
    }

    getSelectedCount() {
        const orders = this.state.export.orders.filter(
            (o) => o.rowIndex != null
        );
        const fixtures = this.state.export.fixtures.filter(
            (f) => f.rowIndex != null
        );

        let total = orders.length + fixtures.length;

        let bothText =
            orders.length !== 0 && fixtures.length !== 0 ? 'BOTH ' : '';
        return total !== 0 ? bothText + '(' + total + ')' : '';
    }

    toggleShowCondensed(showCondensed) {
        if (this.props.onToggleCondensedView) {
            this.props.onToggleCondensedView(showCondensed);
        }
    }

    toggleShowDeleted(showDeleted) {
        const { shouldOnlyDisplayRumouredFixtures } =
            this.props.selectedLayout.fixtures.currentOptions;
        this.handleGridOptionsChanged({
            shouldOnlyDisplayRumouredFixtures: shouldOnlyDisplayRumouredFixtures
                ? false
                : shouldOnlyDisplayRumouredFixtures,
            shouldShowDeletedFixtures: showDeleted,
        });

        MixpanelLogger.trackDataFilterToggle(
            'Fixtures',
            this.props.datasetId,
            this.getSelectedGroup().name,
            'Show Deleted',
            showDeleted
        );
    }

    toggleOnlyDisplayRumouredFixtures() {
        const { shouldOnlyDisplayRumouredFixtures, shouldShowDeletedFixtures } =
            this.props.selectedLayout.fixtures.currentOptions;

        const { filterOptions } =
            this.props.selectedLayout.fixtures.initialOptions;

        const newValue = !shouldOnlyDisplayRumouredFixtures;
        this.handleGridOptionsChanged({
            shouldOnlyDisplayRumouredFixtures: newValue,
            filterOptions: newValue ? undefined : filterOptions,
            shouldShowDeletedFixtures: newValue
                ? false
                : shouldShowDeletedFixtures,
        });

        MixpanelLogger.trackDataFilterToggle(
            'Fixtures',
            this.props.datasetId,
            this.getSelectedGroup().name,
            'Show Rumoured Only',
            newValue
        );
    }

    openAdvancedAnalytics = () => {
        const selectedGroup = this.getSelectedGroup();
        MixpanelLogger.trackOpenAdvancedAnalyticsEvent(selectedGroup.name);

        const token = encodeDataSetId(this.props.datasetId);
        const advancedAnalyticsUrl = `/analytics/${token}`;
        window.open(advancedAnalyticsUrl, '_blank');
    };

    hotkeys = () => [
        {
            keys: [CTRL, KEY_1, KEY_2],
            sub: (e) => {
                e.preventDefault();
                this.toggleShowCondensed(!this.props.useCondensedView);
            },
        },
        {
            keys: [CTRL, ALT, KEY_R],
            sub: (e) => {
                e.preventDefault();
                this.toggleActivity();
            },
        },
        {
            keys: [CTRL, ALT, KEY_D],
            sub: (e) => {
                e.preventDefault();
                this.openAdvancedAnalytics();
            },
        },
    ];

    trackAuditHistoryEvent = () => {
        const selectedFixture = this.state.selectedFixtures[0].data;
        const { id, visibility, privacy } = selectedFixture;
        const selectedGroup = this.getSelectedGroup();

        MixpanelLogger.trackOpenAuditHistoryEvent(
            id,
            'Fixture',
            isGroupOnly(visibility),
            privacy,
            selectedGroup.name
        );
    };

    trackAnalyticEvent = () => {
        const selectedGroup = this.getSelectedGroup();
        MixpanelLogger.trackOpenAnalyticsEvent(selectedGroup.name);
    };

    getSelectedGroup = () => {
        const { groupId, groups } = this.props;
        const group = groups.filter((group) => group.id === groupId)[0];

        return {
            id: groupId,
            name: group.name,
            groupSettings: group.groupSettings,
        };
    };

    setDataSize = (newDataSizeOption) => {
        this.setState({
            numberOfYears: newDataSizeOption.key,
        });

        this.props.onNumberOfYearsChanged &&
            this.props.onNumberOfYearsChanged({
                value: newDataSizeOption.key,
                label: newDataSizeOption.content,
            });

        MixpanelLogger.trackDataFilterToggle(
            'Fixtures',
            this.props.datasetId,
            this.getSelectedGroup().name,
            'Displaying (by time)',
            newDataSizeOption.content
        );
    };

    trackIfDeliveryTermChanged = (params) => {
        if (params.column.colId !== 'deliveryTerm') {
            return;
        }

        MixpanelLogger.trackDeliveryTermValueChanged(params.newValue);
    };

    getRightMenuButtons = (datasetId) => {
        const baseButtons = [];

        if (!this.vesselView) {
            baseButtons.push(
                <ReportsButton
                    key="ReportsButton"
                    id="ReportsButton"
                    datasetId={datasetId}
                    onToggleAnalytics={this.toggleActivity}
                    openAdvancedAnalytics={this.openAdvancedAnalytics}
                />
            );
        }
        if (this.vesselView && !window.location.href.includes('fullscreen')) {
            baseButtons.push(
                <OpenFullscreenTabButton tooltip="Open FORT with Vessel Filter" />
            );
        }

        baseButtons.push(
            <DataButton
                key="DataButton"
                id="DataButton"
                forFixtures={true}
                onToggleShowDeleted={this.toggleShowDeleted}
                showDeleted={
                    this.props.selectedLayout.fixtures.currentOptions
                        .shouldShowDeletedFixtures
                }
                dataSizeOption={this.state.numberOfYears}
                onDataSizeChanged={this.setDataSize}
                shouldOnlyDisplayRumouredFixtures={
                    this.props.selectedLayout.fixtures.currentOptions
                        .shouldOnlyDisplayRumouredFixtures
                }
                onToggleOnlyDisplayRumouredFixtures={
                    this.toggleOnlyDisplayRumouredFixtures
                }
            />
        );

        baseButtons.push(
            <MoreButton
                key="MoreButton"
                id="MoreButton"
                singleView={this.props.singleView}
                showCondensed={this.props.useCondensedView}
                fixturesPage
                onToggleCondensed={this.toggleShowCondensed}
                showMultiViewButton={
                    !this.vesselView && !this.props.isIframeView
                }
            />
        );

        return baseButtons;
    };
    render() {
        const groupId = this.vesselView
            ? tankersUnstructuredDatasetIds.includes(this.props.datasetId)
                ? undefined
                : this.props.groupId
            : this.props.groupId;

        if (!groupId) {
            return (
                <SwitchGroup
                    key="SwitchGroup"
                    isAdmin={this.props.isAdmin}
                    onChange={this.props.handleGroupChange}
                    vesselView={this.vesselView}
                />
            );
        }

        const {
            itemAddedSessionIndex,
            loadingFixtures: loading,
            fixtureLoadingError: error,
            fixturesLoadedDatasetId,
            fixturesLoaded,
            fixtures,
            activeSlide,
        } = this.state;

        const { datasetId } = this.props;
        const dataset = getDataset(datasetId);
        const showActivityTransition = activeSlide === 'activity';

        const renderContent = () => {
            if (error) {
                return <div className="ui error message">{error.message}</div>;
            }

            if (
                (fixturesLoadedDatasetId !== datasetId ||
                    loading ||
                    !fixturesLoaded) &&
                (fixturesLoadedDatasetId !== datasetId || !fixtures)
            ) {
                return <StripedLoader />;
            }

            const { filterOptions, columnOptions } =
                this.props.selectedLayout.fixtures.currentOptions;

            return (
                <BasicGrid
                    ref={this.basicGridRef}
                    insertDefaultLayoutIfNotExist={async (columnOptions) => {
                        await this.props.dispatch(
                            ensureInitialLayout({
                                name: 'My Layout',
                                gridType: 'fixtures',
                                initialGridConfig: { columnOptions },
                            })
                        );
                        return await this.props.dispatch(
                            ensureDefaultColumns({
                                gridType: 'fixtures',
                                initialGridConfig: { columnOptions },
                            })
                        );
                    }}
                    token={datasetId}
                    createdIndex={this.state.createdIndex}
                    gridId="fixtures"
                    selectedGroup={this.getSelectedGroup()}
                    headings={FixtureHeadings.filter(
                        (h) => !dataset.nonAvailableFields.includes(h.colId)
                    )}
                    rowData={fixtures}
                    rerenderParent={this.forceUpdate.bind(this)}
                    onGridReady={this.handleGridReady}
                    defaultSetter={(params) => {
                        if (
                            params.colDef.field === 'reportedDate' &&
                            !isReportedDateValid(params.newValue)
                        ) {
                            params.context.cellErrors.setError({
                                rowId: params.data.id,
                                colId: params.colDef.field,
                                error: new Error('Reported Date is required'),
                            });
                            params.api.refreshCells({
                                rowNodes: [params.node],
                            });
                            return;
                        }
                        this.fixtureValueSetter(params);
                        this.trackIfDeliveryTermChanged(params);
                    }}
                    getDataId={this.getFixtureId}
                    initialFilterOptions={filterOptions}
                    initialColumnOptions={columnOptions}
                    userGridOptionsUpdated={this.handleGridOptionsChanged}
                    defaultGroupSortComparator={(nodeA, nodeB) =>
                        defaultGroupSortComparator(
                            nodeA,
                            nodeB,
                            this.props.selectedLayout.fixtures.currentOptions
                                .rowGroupsSorting
                        )
                    }
                    onSidebarClickOutside={this.handleSidebarClickOutside}
                    rowClassRules={commonRowAndCellClassRules}
                    itemAddedSessionIndex={itemAddedSessionIndex}
                    exportColIdsToSkip={this.state.exportColIdsToSkip}
                    onMakePublic={this.makePublic}
                    onMakePrivate={this.makePrivate}
                    onMakeUnRumoured={this.makeUnRumoured}
                    onMakeRumoured={this.makeRumoured}
                    onDelete={this.delete}
                    onShare={this.share}
                    onShareToGroup={this.shareToGroup}
                    onUpdatePrivateFields={this.updatePrivateFields}
                    onUpdateRumouredFields={this.updateRumouredFields}
                    onSelectionChanged={this.handleSelectionChanged}
                    showCondensed={this.props.useCondensedView}
                    onReinstate={this.reinstate}
                    onCopyFixture={this.copyFixture}
                    onCopyFixtureWithCargoInfo={this.copyFixtureWithCargoInfo}
                    canPerformAction={this.handleCanPerformAction}
                    onOpenAuditActivity={this.handleOpenAuditActivity}
                    onOpenVoyageActivity={this.handleOpenVoyageActivity}
                    isAdmin={this.props.isAdmin}
                    showTotalsInStatusBar={true}
                    singleView={this.props.singleView && !this.vesselView}
                    vesselView={this.vesselView}
                    displayPeriodLabel={
                        dataSizeOptions.find(
                            (o) => o.value === this.state.numberOfYears
                        )?.label
                    }
                    canEdit={this.props.canEdit}
                    hotkeys={this.hotkeys}
                    userTimezone={this.props.userTimezone}
                    currentDirectionLogic={
                        this.props.selectedLayout.commonSettings.directionLogic
                            .currentState
                    }
                    currentQuantityFormat={
                        this.props.selectedLayout.commonSettings.quantityFormat
                            .currentState
                    }
                    currentRateFormat={
                        this.props.selectedLayout.commonSettings.rateFormat
                            .currentState
                    }
                    selectedLayoutId={
                        this.props.selectedLayout.selectedLayoutId
                    }
                    groupingToolPanel={GroupingFixturesToolPanel}
                    onCollapsedRowGroupsChanged={
                        this.handleOnCollapsedRowGroupsChanged
                    }
                    currentCollapsedRowGroups={
                        this.props.selectedLayout.fixtures.collapsedRowGroups
                    }
                    groupRowRendererParams={{
                        suppressCount: true,
                        innerRenderer: (value) =>
                            getGroupingText(value, customFixtureGroupHeaders),
                    }}
                    onCellEditingStopped={this.handleOnCellEditingStopped}
                />
            );
        };

        return (
            <GridContextProvider gridType="fixtures">
                <div
                    className="flex-container"
                    style={{
                        height: '100%',
                    }}
                >
                    <div className="flex-item-fill" style={{ width: '100%' }}>
                        <Toolbar
                            leftMenu={[
                                this.props.canEdit && (
                                    <AddFixture
                                        key="AddFixture"
                                        onCompleted={this.handleNewFixture}
                                        vesselImo={this.state.vesselImo}
                                        disabled={!this.state.gridReady}
                                    />
                                ),
                                this.props.singleView ? (
                                    <SwitchGroup
                                        isAdmin={this.props.isAdmin}
                                        onChange={this.props.handleGroupChange}
                                        vesselView={this.vesselView}
                                        key="SwitchGroup"
                                    />
                                ) : null,
                                this.props.singleView ? (
                                    <LayoutsDropdownMenu />
                                ) : null,
                                <Filters
                                    key="Filters"
                                    headings={FixtureHeadings}
                                    datasetId={datasetId}
                                    initialFilters={
                                        this.props.selectedLayout.fixtures
                                            .initialOptions.filterOptions
                                    }
                                    currentFilters={
                                        this.props.selectedLayout.fixtures
                                            .currentOptions.filterOptions
                                    }
                                    currentOptions={
                                        this.props.selectedLayout.fixtures
                                            .currentOptions
                                    }
                                    onGridOptionsChanged={(
                                        currentLayoutOptions
                                    ) => {
                                        this.props.dispatch(
                                            changeGridSettings({
                                                gridType: 'fixtures',
                                                gridSettings:
                                                    currentLayoutOptions,
                                            })
                                        );
                                    }}
                                />,
                            ]}
                            chips={[
                                this.props.selectedLayout.fixtures
                                    .currentOptions
                                    .shouldShowDeletedFixtures && (
                                    <ChipOutlined
                                        key="showingDeleted"
                                        label="SHOWING DELETED"
                                        onDelete={() => {
                                            this.toggleShowDeleted(false);
                                        }}
                                    />
                                ),
                                this.props.selectedLayout.fixtures
                                    .currentOptions
                                    .shouldOnlyDisplayRumouredFixtures && (
                                    <ChipOutlined
                                        key="displayRumouredOnly"
                                        label="DISPLAY RUMOURED ONLY"
                                        onDelete={() => {
                                            this.toggleOnlyDisplayRumouredFixtures(
                                                false
                                            );
                                        }}
                                    />
                                ),
                            ]}
                            rightMenuIcons={[
                                this.vesselView && (
                                    <div
                                        className="toolbar-not-selectable"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            gap: 8,
                                        }}
                                    >
                                        <span style={{ fontWeight: 'bold' }}>
                                            {this.state.vesselName}
                                        </span>
                                        <span style={{ color: 'gray' }}>
                                            IMO: {this.state.vesselImo}
                                        </span>
                                    </div>
                                ),
                                this.state.export.fixtures.length > 0 &&
                                    this.state.export.orders.length === 0 && (
                                        <ExportButton
                                            key="ExportButton"
                                            id="ExportButton"
                                            selectedCount={this.getSelectedCount()}
                                            onClick={this.props.onExportClicked}
                                        />
                                    ),
                                <SyncButton
                                    key="SyncButton"
                                    id="SyncButton"
                                    onClick={this.refreshLayout}
                                />,
                            ]}
                            rightMenuButtons={this.getRightMenuButtons(
                                datasetId
                            )}
                        />
                        <div>
                            <CSSTransition
                                classNames="activity"
                                in={showActivityTransition}
                                timeout={300}
                                unmountOnExit
                            >
                                <Activity
                                    onClose={this.toggleActivity}
                                    datasetId={datasetId}
                                    forFixtures={true}
                                    context={this.props.context}
                                    selectedFixtures={
                                        this.state.selectedFixtures
                                    }
                                    selectedTab={
                                        this.state.activity.selectedTab
                                    }
                                    trackAuditHistoryEvent={
                                        this.trackAuditHistoryEvent
                                    }
                                    trackAnalyticEvent={this.trackAnalyticEvent}
                                />
                            </CSSTransition>
                        </div>

                        {renderContent.bind(this)()}
                    </div>
                </div>
            </GridContextProvider>
        );
    }

    handleGridOptionsChanged(params) {
        const {
            filterOptions,
            columnOptions,
            shouldResetSessionIndex,
            rowGroupsSorting,
            rowGroups,
            shouldOnlyDisplayRumouredFixtures,
            shouldShowDeletedFixtures,
        } = params;
        const currentOptions =
            this.props.selectedLayout.fixtures.currentOptions;

        const deliveryTermHideState = compareColumnPropertyState(
            'deliveryTerm',
            currentOptions.columnOptions,
            columnOptions,
            'hide'
        );
        if (deliveryTermHideState.hasChanged) {
            MixpanelLogger.trackDeliveryTermVisibilityChange(
                !deliveryTermHideState.newValue
            );
        }

        if (shouldResetSessionIndex) {
            this.resetAddedSessionIndex();
        }

        const currentLayoutOptions = {
            filterOptions: filterOptions ?? currentOptions.filterOptions,
            columnOptions: columnOptions ?? currentOptions.columnOptions,
            vesselOptions: currentOptions.vesselOptions,
            rowGroups: rowGroups ?? currentOptions.rowGroups,
            rowGroupsSorting:
                rowGroupsSorting ?? currentOptions.rowGroupsSorting,
            shouldOnlyDisplayRumouredFixtures:
                shouldOnlyDisplayRumouredFixtures ??
                currentOptions.shouldOnlyDisplayRumouredFixtures,
            shouldShowDeletedFixtures:
                shouldShowDeletedFixtures ??
                currentOptions.shouldShowDeletedFixtures,
        };

        this.props.dispatch(
            changeGridSettings({
                gridType: 'fixtures',
                gridSettings: currentLayoutOptions,
            })
        );
    }

    saveLayout = (
        fixturesOptions,
        ordersOptions,
        collapsedRowGroups,
        commonSettings
    ) => {
        const fixturesLayout = {
            filters: { ...fixturesOptions.filterOptions },
            columnState: [...fixturesOptions.columnOptions],
            vesselOptions: fixturesOptions.vesselOptions,
            rowGroupsSorting: fixturesOptions.rowGroupsSorting,
            rowGroups: fixturesOptions.rowGroups,
            shouldOnlyDisplayRumouredFixtures:
                fixturesOptions.shouldOnlyDisplayRumouredFixtures,
            shouldShowDeletedFixtures:
                fixturesOptions.shouldShowDeletedFixtures,
            collapsedRowGroups: collapsedRowGroups,
        };
        const ordersLayout = {
            filters: { ...ordersOptions.filterOptions },
            columnState: [...ordersOptions.columnOptions],
            shouldHighlightNewOrders: ordersOptions.shouldHighlightNewOrders,
            shouldShowConvertedOrders: ordersOptions.shouldShowConvertedOrders,
            shouldOnlyDisplayRumouredOrders:
                ordersOptions.shouldOnlyDisplayRumouredOrders,
            rowGroupsSorting: ordersOptions.rowGroupsSorting,
            rowGroups: ordersOptions.rowGroups,
            collapsedRowGroups:
                this.props.selectedLayout.orders.collapsedRowGroups,
        };

        layoutsApi.persistLayout(
            this.props.datasetId,
            this.props.allLayouts,
            this.props.selectedLayout.selectedLayoutId,
            ordersLayout,
            fixturesLayout,
            commonSettings,
            this.props.actions.onUpdateLayouts
        );
    };

    sendSaveLayoutMixpanelEvent = (
        layoutName,
        gridType,
        layoutItems,
        localGridOptions
    ) => {
        sendSaveLayoutMixpanelEvent(
            layoutName,
            gridType,
            layoutItems,
            localGridOptions,
            this.props.selectedLayout.commonSettings.directionLogic
                .currentState,
            this.props.selectedLayout.commonSettings.quantityFormat
                .currentState,
            this.state.exportColIdsToSkip,
            this.props.datasetId
        );
    };

    getMixpanelGridOptions = () => {
        const gridOptions = {
            showDeleted:
                this.props.selectedLayout.fixtures.currentOptions
                    .shouldShowDeletedFixtures,
            selectedNumberOfYears: this.state.numberOfYears,
        };

        return gridOptions;
    };

    getMixpanelOrdersGridOptions = () => {
        const gridOptions = {
            showDeletedAndWithdrawn:
                this.props.selectedLayout.orders.currentOptions
                    .shouldShowDeletedOrders,
        };

        return gridOptions;
    };

    handleOnSaveLayout = () => {
        const fixturesOptions =
            this.props.selectedLayout.fixtures.currentOptions;
        const ordersOptions = this.props.selectedLayout.orders.currentOptions;
        const commonSettings = {
            directionLogic:
                this.props.selectedLayout.commonSettings.directionLogic
                    .currentState,
            quantityFormat:
                this.props.selectedLayout.commonSettings.quantityFormat
                    .currentState,
            defaultType:
                this.props.selectedLayout.commonSettings.defaultType
                    .currentState,
        };

        this.saveLayout(
            fixturesOptions,
            ordersOptions,
            this.props.selectedLayout.fixtures.collapsedRowGroups,
            commonSettings
        );

        const { wereOptionsChanged: wereFixturesOptionsChanged } =
            this.props.selectedLayout.fixtures;
        const { wereOptionsChanged: wereOrdersOptionsChanged } =
            this.props.selectedLayout.orders;
        const currentLayout = this.getCurrentLayout();
        const isDirectionLogicChanged =
            !layoutActions.isCurrentDirectionLogicEqualToInitialOne(
                this.props.selectedLayout.commonSettings.directionLogic
            );
        const isQuantityFormatChanged =
            !layoutActions.isCurrentQuantityFormatEqualToInitialOne(
                this.props.selectedLayout.commonSettings.quantityFormat
            );

        const gridOptions = this.getMixpanelGridOptions();

        if (
            wereOrdersOptionsChanged ||
            isDirectionLogicChanged ||
            isQuantityFormatChanged
        ) {
            this.sendSaveLayoutMixpanelEvent(
                currentLayout.name,
                'Order',
                this.props.selectedLayout.orders,
                gridOptions
            );
        }

        if (
            wereFixturesOptionsChanged ||
            isDirectionLogicChanged ||
            isQuantityFormatChanged
        ) {
            this.sendSaveLayoutMixpanelEvent(
                currentLayout.name,
                'Fixture',
                this.props.selectedLayout.fixtures,
                gridOptions
            );
        }

        this.props.actions.onSaveLayout();
    };

    // TODO: refactor now
    handleOnCollapsedRowGroupsChanged = (collapsedRowGroups) => {
        this.props.dispatch(
            changeCollapsedRowGroups({
                gridType: 'fixtures',
                collapsedRowGroups: collapsedRowGroups,
            })
        );

        // next method should be invoked to recalculate the count of selected rows
        this.handleSelectionChanged();
    };

    sendCreateLayoutMixpanelEvent = (
        layoutName,
        gridType,
        reduxGridOptions,
        directionLogic,
        quantityFormat,
        gridOptions
    ) => {
        const layoutProperties = getCreatedLayoutPropertiesForMixpanel(
            reduxGridOptions,
            this.state.exportColIdsToSkip,
            gridType,
            directionLogic,
            quantityFormat,
            this.props.datasetId,
            gridOptions
        );
        MixpanelLogger.trackCreateLayoutEvent(layoutName, layoutProperties);
    };
}

const mapStateToProps = (state) => {
    const {
        group,
        groups,
        username,
        userId,
        headingDefaults,
        permissions,
        userTimezone,
    } = state.user;

    const props = {
        selectedLayout: state.layouts.selectedLayout,
        allLayouts: state.layouts.allLayouts,
        headingDefaults: headingDefaults,
        username: username,
        userId: userId,
        userTimezone: userTimezone,
        groupId: group ? group.id : null,
        datasetId: group ? group.datasetId : null,
        groups,
        creationIndex: currentGridCreationIndex(state, FIXTURE_GRID_TYPE),
        canEdit: permissions.some((p) => p.groupId === group.id && p.canWrite),
    };

    return props;
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(
            { ...userActions, ...layoutActions },
            dispatch
        ),
        dispatch,
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        actions: {
            ...dispatchProps.actions,
            userChangedGridOptions: (filterOptions, columnOptions) => {
                if (stateProps.groupId) {
                    dispatchProps.actions.userChangedGridOptions(
                        stateProps.groupId,
                        filterOptions,
                        columnOptions,
                        FIXTURE_GRID_TYPE
                    );
                }
            },
            userCreationIndexSet: (index) => {
                dispatchProps.actions.userCreationIndexSet(
                    index,
                    FIXTURE_GRID_TYPE
                );
            },
        },
    };
};

FixturesPage = withApollo(FixturesPage, { withRef: true });

export default connect(mapStateToProps, mapDispatchToProps, mergeProps, {
    forwardRef: true,
})(FixturesPage);
